import classNames from 'classnames';

export default function Switch({ value, options, onChange }) {
  return (
    <div className="flex bg-zinc-800 items-center rounded-2xl">
      {options.map((option) => (
        <div
          key={option.value}
          onClick={() => onChange(option)}
          className={classNames('font-semibold text-xs w-[120px] h-[36px] cursor-pointer flex items-center justify-center', {
            'bg-[#08865C]': option.value === value.value,
            'rounded-[18px]': option.value === value.value
          })}
        >
          {option.label}
        </div>
      ))}
    </div>
  )
}
